import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from '../store';
import OrganizationService from '@/domain/Organization/OrganizationService';
import UserService from '@/domain/Users/UserService';

const organizationService = new OrganizationService();
const userService = new UserService();

const organizationSettingsRaw = localStorage.getItem('organizationSettings');
const organizationSettings = organizationSettingsRaw ? JSON.parse(organizationSettingsRaw) : null;

const initialState: any = {
  settings:
    organizationSettings && !Array.isArray(organizationSettings) && organizationSettings.mapSettings
      ? organizationSettings
      : {
          mapSettings: {
            settings: {
              style: 'mapbox://styles/mapbox/light-v11',
            },
          },
        },
};

const organizationSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    setOrganizationSettings(state, action) {
      state.settings = action.payload;
    },
  },
});

export const { setOrganizationSettings } = organizationSlice.actions;
export default organizationSlice.reducer;

// Thunk para obtener las configuraciones de la organización
export const getOrganizationSettingsAction =
  (organizationId: string | number) => async (dispatch: AppDispatch) => {

    const userId = localStorage.getItem('userId') || '';

    // const res = await organizationService.getOrganizationsSettings(userId);

    const res = await userService.getUsersSettings(userId);

    if (res?.mapSettings) {
      dispatch(setOrganizationSettings(res));
      localStorage.setItem('organizationSettings', JSON.stringify(res));
    } else {
      const savedSettingsRaw = localStorage.getItem('organizationSettings');
      const savedSettings = savedSettingsRaw ? JSON.parse(savedSettingsRaw) : null;

      if (savedSettings?.mapSettings) {
        dispatch(setOrganizationSettings(savedSettings));
      } else {
        const defaultSettings = {
          mapSettings: {
            settings: {
              style: 'mapbox://styles/mapbox/light-v11',
            },
          },
        };
        dispatch(setOrganizationSettings(defaultSettings));
        localStorage.setItem('organizationSettings', JSON.stringify(defaultSettings));
      }
    }
  };
